import Lightbox from "bs5-lightbox";

export const initLightbox = function (config) {
  for (const el of document.querySelectorAll('.lightbox')) {
    el.addEventListener('click', Lightbox.initialize)
  }
}
